import firebase, { FS_COLLECTIONS } from '@/firebase';
import moment from 'moment';
const db = firebase.firestore();

import { handleGetColecction, handleSelectedFirebase } from '@/constantes/helpers';
import { LISTA_OPCIONES_REPORTE } from '@/constantes/reportes/utils';
import {
  obtenerSaldoGenerado, obtenerTotalPagosPendientes, obtenerServicioSinEvidencias, obtenerTotalPagosRealizados, obtenerTotalTicket
} from '@/constantes/saldo/index.js';

const tieneDescuentoServicios = (servicios = []) => {
  return servicios.some(e=>e.tiene_descuento)
}

/**
 * @param {firebase.firestore.Query<firebase.firestore.DocumentData>} docRef
 * @param {FILTROS_REPORTE} filtros
 */
 const crearFiltrosAdicionalesTicket = (docRef, filtros) => {
  
  const {sucursal, colaborador} = filtros.filtro2
  const {propietario} = filtros.filtro1
  const estatus = filtros.filtro3.estatus

  //docRef = handleSelectedFirebase(docRef,sucursal,'sucursal')
  //docRef = handleSelectedFirebase(docRef,colaborador,'responsable.id')
  docRef = handleSelectedFirebase(docRef,propietario,'id_propietario')

  if(estatus){
    if(estatus!='AMBOS'){
      const campos = estatus==='DEUDA' ? ['Positivo','negativo'] : ['Exacto']
      console.log("Campos ", campos)
      docRef = docRef.where('saldo','in',campos)
    }
  }

  return docRef

}

const store = {
  state: {
  },
  getters: {

  },
  mutations: {
  },
  actions: {
    async obtenerTicketsFiltrados({getters}, filtros){

      console.log("filtros ticket", filtros)
      let fechaDel = filtros.filtro1.fecha.del.fecha
      let fechaAl = filtros.filtro1.fecha.al.fecha

      const reporteSeleccionado = LISTA_OPCIONES_REPORTE[filtros.reporteSeleccionado]
      const anio = filtros.filtro1.fecha.anio

      if(reporteSeleccionado===LISTA_OPCIONES_REPORTE.ESTADISTICA_VENTAS_MES){
        
        fechaDel = new Date(`01-01-${anio}`)
        fechaAl = new Date(`12-31-${anio}`)
      }
      console.log("Anio ", anio)
      console.log("Fecha del ", fechaDel)
      console.log("Fecha al ", fechaAl)

      const {esVentaMostrador = false} = filtros
      const campo = 'fecha_alta'
      const documento = !esVentaMostrador ? FS_COLLECTIONS.TICKETS : FS_COLLECTIONS.TICKETS_VENTAS_MOSTRADOR
      let docRef = db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(getters.franquicia.id)
      .collection(documento).where(campo,'>=',fechaDel).where(campo,'<=',fechaAl)
      docRef =  crearFiltrosAdicionalesTicket(docRef, filtros)

      let tickets = await handleGetColecction(docRef)

      const ticketFitros = filtros.filtro3.ticket

      if(ticketFitros.seleccionado){
        tickets = tickets.filter(e => {
          // return ticketFitros.del_folio>=e.id_numerico && ticketFitros.al_folio<=e.id_numerico
          return e.id_numerico>=ticketFitros.del_folio && e.id_numerico<=ticketFitros.al_folio
        })
      }

      console.log("Tickets filtrados ", tickets)

      return tickets

    },
    async validarAsignarMonederoEnPropietario({getters}, props){

      const {total, servicios, ticket, aplicoMonedero = false} = props

      console.log("Vlidar monedero en propietario ", total)
      console.log("Sergv ", servicios)
      console.log(aplicoMonedero)

      try {
        
        //Si ese monedero ya fue aplicado una vez en el ticket entonces ya no pasa nada
        if (aplicoMonedero) return;

        //Si el ticket no esta saldado entonces no hacemos nada
        if(parseFloat(total)!==0) return false

        //TODO: Validar si tiene hospitalizacion
        //Si no encontramos ningun servicio con descuento entonces no hacemos anda
        if(!tieneDescuentoServicios(servicios)) return false
        //Calculamos el total de descuento para asignar al monedero del propietario

        let totalMonedero = 0
        const propietario = getters.propietarioTiempoReal
        let monederoPropietario = parseFloat(
          JSON.parse(JSON.stringify(propietario.monedero))
        )

        for(const i in servicios){

          const servicio = servicios[i]
          
          if(servicio.tiene_descuento){

            const servicioEncontrado = getters.listaServiciosCasosCopia.servicios_caso[servicio.id_servicio_caso]

            totalMonedero+=parseFloat(servicioEncontrado.descuento.cantidad)

          }

        }

        monederoPropietario+=parseFloat(totalMonedero)

        console.log("Monedero propietario ", monederoPropietario)
        const batch = db.batch()

        batch.update(db.collection(FS_COLLECTIONS.PROPIETARIOS).doc(propietario.id),{monedero:monederoPropietario})
        batch.update(
          db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(getters.franquicia.id)
          .collection(FS_COLLECTIONS.TICKETS).doc(ticket), {aplicoMonedero:true,}
        )

        await batch.commit()

        return false;

      } catch(e){

        console.log("Error validar asignar monedero en propietarios ", e)

        return false;

      }

    },
    regresarAnticipoEnPropietario({getters},props){

      const {
        anticipo, propietario = getters.propietarioTiempoReal,
      } = props;

      const anticipos = propietario.anticipos || []
      //Buscamos entre los anticipos del propietario uno que existe con el anticipo del ticket para regresarlo a no usado
      for(const i in anticipos){
        if(anticipos[i].id===anticipo.id){
          anticipos[i].usado = false;
        }
      }

      console.log("Regresar anticipos a propietario ", anticipos)

      return new Promise((resolve,reject) => {

        db.collection(FS_COLLECTIONS.PROPIETARIOS).doc(propietario.id).update({anticipos:anticipos}).then(() => {
          resolve()
        }).catch(error=>{
          reject(error)
        })

      })

    },
    async actualizarPagosTicket({getters,dispatch},props){
      
      const {
        id_ticket,pagos,pagoAnterior = {}
      } = props

      console.log("Props actualizar pagos ticket ", props)
      return new Promise(async(resolve, reject) => {
      try {

        const ticket = getters.indiceTicketsStatic.find(e=>e.id_numerico===id_ticket)

        if(!ticket) throw "No hay ticket"

        const promesas = []
        
        if(pagoAnterior.forma_pago==='Anticipos'){
          promesas.push(dispatch('regresarAnticipoEnPropietario',{anticipo:pagoAnterior}))
        }

        const total_pagos_realizados = obtenerTotalPagosRealizados(pagos)
        const total_pagos_pendientes = obtenerTotalPagosPendientes(ticket.pagos_pendientes)

        const ticketActualizar = {
          pagos_realizados:pagos,
          ttotal_pagos_pendientes:String(total_pagos_pendientes),
          total_pagos_realizados:String(total_pagos_realizados),
          saldo:obtenerSaldoGenerado(total_pagos_pendientes,total_pagos_realizados),
        }

        promesas.push(db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(getters.franquicia.id).
        collection(FS_COLLECTIONS.TICKETS).doc(ticket.id).update(ticketActualizar))

        await Promise.all(promesas)

        resolve(true);

      } catch(e){

        console.error("Error desde store saldo ", e)

        reject(e);

      }
      });

    },

    async actualizarPagosVentasMostrador({getters},props){

      const {
        id_ticket,pagos = {}
      } = props

      console.log("Props actualizar pagos ticket ", props)
      return new Promise(async(resolve, reject) => {
      try {

        //const ticket = getters.indiceTicketsVentasMostrador.find(e=>e.id_numerico===id_ticket)
        const ticket = getters.indiceTicketsVentasMostrador.find(e=>e.id_numerico===id_ticket)

        if(!ticket) throw "No hay ticket"

        const promesas = []
        
        // if(pagoAnterior.forma_pago==='Anticipos'){
        //   promesas.push(dispatch('regresarAnticipoEnPropietario',{anticipo:pagoAnterior}))
        // }

        const total_pagos_realizados = obtenerTotalPagosRealizados(pagos)
        const total_pagos_pendientes = obtenerTotalPagosPendientes(ticket.pagos_pendientes)

        const ticketActualizar = {
          pagos_realizados:pagos,
          ttotal_pagos_pendientes:String(total_pagos_pendientes),
          total_pagos_realizados:String(total_pagos_realizados),
          saldo:obtenerSaldoGenerado(total_pagos_pendientes,total_pagos_realizados),
        }

        promesas.push(db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(getters.franquicia.id).
        collection(FS_COLLECTIONS.TICKETS_VENTAS_MOSTRADOR).doc(ticket.id).update(ticketActualizar))

        await Promise.all(promesas)

        resolve(true);

      } catch(e){

        console.error("Error desde store saldo ", e)

        reject(e);

      }
      });

    },





    async asignarIdTicketEnServicios({getters},props){

      const {servicios, no_ticket, ticket, esVentaMostrador} = props

      try {

        const promesas = []
        const coleccion = !esVentaMostrador ? FS_COLLECTIONS.SERVICIOS_CASOS 
        : FS_COLLECTIONS.VENTAS_MOSTRADOR

        for(const i in servicios){
          const ref = db.collection(FS_COLLECTIONS.FRANQUICIAS)
          .doc(getters.franquicia.id).collection(coleccion)
          .doc(servicios[i].id_servicio_caso)
          promesas.push(
            ref.update({
              no_ticket:no_ticket,
              ticket:ticket,
            })
          )
        }

        await Promise.all(promesas)

        return true;

      } catch(e){
        
        throw e;

      }

    },
    async crearTicket({dispatch}, props){
      return new Promise(async(resolve, reject) => {
      let {servicios} = props
      console.log("Props crear ticket ", props)

      try {

        //Mandamos a asignar los pagos a un ticket ya existente si ninguno tiene un id numero
        const tieneTicketsAsignados = servicios.some(e=>e.no_ticket!==0)

        if(tieneTicketsAsignados){
          console.log("🚀 tieneTicketsAsignados", true)
          await dispatch('realizarPagosEnTicket',props)
        }else{
          console.log("🚀 tieneTicketsAsignados", false)
          await dispatch('crearNuevoTicket', props)
        }
        
        resolve(true)

      } catch(e){
        console.error("🚀 ~ file: index.js ~ line 312 ~ returnnewPromise ~ e", e)
        reject(e);
      }
      });

    },
    async validarSiTieneAnticipos({getters}, props){

      const {pagos} = props
      const idPropietario = getters.propietarioActual.id
      const {anticipos} = getters.propietarioTiempoReal

      const pagosConAnticipo = pagos.filter(e=>e.forma_pago==="Anticipos")

      if(!pagosConAnticipo.length) return

      const anticiposGuardar = []

      anticipos.forEach(e => {

        let usado = e.usado

        if(!usado){
          usado = pagosConAnticipo.find(anticipo=>anticipo.id===e.id) ? true : false
        }

        anticiposGuardar.push({
          ...e,
          usado
        })

      })

      return await db.collection(FS_COLLECTIONS.PROPIETARIOS).doc(idPropietario).update({anticipos:anticiposGuardar})

    },
    async crearNuevoTicket({dispatch, getters},props){

      console.log("Ejecuta crear nuevo ticket", props)
      return new Promise(async(resolve, reject) => {
      try {

        let {servicios, pagos, esVentaMostrador} = props

        if(!servicios.length) return 

        const date = new Date()
        const responsable = JSON.parse(JSON.stringify(getters.indiceUsuarios[getters.usuario.id]))
        const idNumerico = await dispatch('actualizarUltimoIdTicket',{})
        const total_pagos_pendientes = obtenerTotalPagosPendientes(servicios)
        const total_pagos_realizados = obtenerTotalPagosRealizados(pagos)

        const servicios_sin_evidencias = obtenerServicioSinEvidencias(servicios);

        const ticket = {
          anio:String(date.getFullYear()),
          mes:("0" + (parseInt(date.getMonth()) + 1)).slice(-2),
          fecha:moment(date).format('DD/MM/YYYY'),
          fecha_alta:date,
          finalizado:false,
          id_numerico:idNumerico,
          numero_ticket:"",
          pagos_pendientes:servicios_sin_evidencias,
          pagos_realizados:pagos,
          responsable:responsable,
          saldo:obtenerSaldoGenerado(total_pagos_pendientes,total_pagos_realizados),
          sucursal:sucursal,
          total_pagos_pendientes:String(total_pagos_pendientes),
          total_pagos_realizados:String(total_pagos_realizados),
        }
        console.log("Es venta mostrador ", esVentaMostrador)
        const sucursal = !esVentaMostrador ? 
        JSON.parse(JSON.stringify(getters.caso.sucursal.id)) :
        JSON.parse(JSON.stringify(getters.sucursalActual))
        ticket.sucursal = sucursal

        if(!esVentaMostrador){
          ticket.id_propietario = JSON.parse(JSON.stringify(getters.propietarioActual.id))
        }
        const coleccion = !esVentaMostrador ? FS_COLLECTIONS.TICKETS 
        : FS_COLLECTIONS.TICKETS_VENTAS_MOSTRADOR
        const res = await db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(getters.franquicia.id)
        .collection(coleccion).add(ticket)

        const promesas = []
        const total = obtenerTotalTicket(total_pagos_pendientes,total_pagos_realizados)

        if(!esVentaMostrador){
          promesas.push(
            dispatch(
              'validarSiTieneAnticipos',
              {
                pagos,
              }
            )
          )
        }

        if(!esVentaMostrador){
          promesas.push(
            dispatch(
              'validarAsignarMonederoEnPropietario',
              {
                total:total,
                servicios:servicios,
                ticket:res.id,
              }
            )
          )
        }

        promesas.push(
          dispatch(
            'asignarIdTicketEnServicios',
            {
              no_ticket:idNumerico,
              ticket:res.id,
              servicios:servicios,
              esVentaMostrador
            }
          )
        )

        await Promise.all(promesas)

        resolve(true);

      } catch(e){
        console.error("🚀 ~ file: index.js ~ line 435 ~ returnnewPromise ~ e", e)
        reject(e);
      }
      });

    },
    async realizarPagosEnTicket({getters, dispatch},props){
      return new Promise(async(resolve, reject) => {
      let {servicios, pagos, esVentaMostrador} = props

      pagos = JSON.parse(JSON.stringify(pagos))
      const ticketsCargados = {}
      const serviciosNuevos = []

      try {

        //Ordenamos por mas recientes los servicios
        servicios = servicios.sort((a,b) => a.fechaLabel - b.fechaLabel )
        //Ordenamos por mas caro en pagos primero
        pagos = pagos.sort((a,b)=>a.monto-b.monto)

        const promesas = []
        const obtenerCantidadRestante = (pagosRealizados, pagosPendientes) => {
          return obtenerTotalPagosPendientes(pagosPendientes) - 
          obtenerTotalPagosRealizados(pagosRealizados)
        }

        const indiceTicketsStatic = !esVentaMostrador ? getters.indiceTicketsStatic : getters.indiceTicketsVentasMostrador
        //const indiceTicketsVentasMostrador = esVentaMostrador ? getters.indiceTicketsVentasMostrador : getters.indiceTicketsVentasMostrador

        //Esto es para los servicios que tienen ticket asignado
        for(const i in servicios){
          const servicio = servicios[i]
          //TODO: Meter esto en una funcion y crear un algoritmo para buscar la cantidad mas proxima al precio de un servicio
          if(pagos.length){
           
            const id_ticket = servicio.ticket;
            //Aqui asignaremos los pagos unicamente a los tickets que tienen un id de ticket
            if(servicio.no_ticket!==0){
              //Si no tiene cargado el ticket de ese servicio entonces lo cargamos
              if(!ticketsCargados[id_ticket]){
                ticketsCargados[id_ticket] = JSON.parse(JSON.stringify(indiceTicketsStatic.find(e=>e.id===id_ticket)))
              }
              //Realizamos los pagos
              let cantidadRestante = obtenerCantidadRestante(
                ticketsCargados[id_ticket].pagos_realizados,
                ticketsCargados[id_ticket].pagos_pendientes,
              )
              console.log("Cantidad restante priemmro ", cantidadRestante)
              //Asignamos cada pago hasta que la cantidad del saldo sea negativa o 0 para pasar a otro pago
              while(pagos.length && cantidadRestante >0 ) {

                const pago = pagos[pagos.length-1]

                ticketsCargados[id_ticket].pagos_realizados.push(pago)
                pagos.pop()

                cantidadRestante = obtenerCantidadRestante(
                  ticketsCargados[id_ticket].pagos_realizados,
                  ticketsCargados[id_ticket].pagos_pendientes,
                )
                //Si el pago da saldo negativo entonces creamos un nuevo pago con ese restante acumulado
                if(cantidadRestante<0){
                  //Le restamos la diferencia al ultimo pago asignado para que no se pase de exacto el ticket
                  ticketsCargados[id_ticket].pagos_realizados[
                    ticketsCargados[id_ticket].pagos_realizados.length-1
                  ].monto+=cantidadRestante

                  const pagoRestante = JSON.parse(JSON.stringify(pago))

                  pagoRestante.monto=Math.abs(cantidadRestante)
                  pagos.push(pagoRestante)
                  //console.log("Se va a añadir un nuevo pago residual generado ", pago)
                }

              }
              

            }

          }

          if(servicio.no_ticket===0){
            serviciosNuevos.push(servicio)
          }

        }

        //Actualizamos los tickets cargados con su nueva info de pagos
        const coleccion = !esVentaMostrador ? FS_COLLECTIONS.TICKETS : FS_COLLECTIONS.TICKETS_VENTAS_MOSTRADOR
        for(const i in ticketsCargados ){
          
          const ticket = ticketsCargados[i]
          const pagosPendientes = obtenerTotalPagosPendientes(ticket.pagos_pendientes)
          const pagosRealizados = obtenerTotalPagosRealizados(ticket.pagos_realizados)
          const total = obtenerTotalTicket(pagosPendientes,pagosRealizados)
          const ticketActualizar = {
            saldo:obtenerSaldoGenerado(pagosPendientes,pagosRealizados),
            total_pagos_pendientes:String(pagosPendientes),
            total_pagos_realizados:String(pagosRealizados),
            pagos_pendientes:ticket.pagos_pendientes,
            pagos_realizados:ticket.pagos_realizados,
          }

          if(!esVentaMostrador){
            promesas.push(
              dispatch(
                'validarAsignarMonederoEnPropietario',
                {
                  total:total,servicios:ticket.pagos_pendientes,
                  ticket:ticket.ticket,
                  aplicoMonedero:ticket.aplicoMonedero || false,
                }
              )
            )
          }

          if(!esVentaMostrador){
            promesas.push(
              dispatch(
                'validarSiTieneAnticipos',
                {
                  pagos:ticket.pagos_realizados,
                }
              )
            )
          }

          const ref = db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(getters.franquicia.id)
          .collection(coleccion).doc(ticket.ticket)

          promesas.push(ref.update(ticketActualizar))

        }

        //Si hay servicios sin ticket asignado entonces creamos un nuevo ticket
        if(serviciosNuevos.length){
          promesas.push(dispatch('crearNuevoTicket',{
            servicios:serviciosNuevos,
            pagos,
            esVentaMostrador
          }))
        }

        await Promise.all(promesas)
        resolve(true);
      } catch(e){
        console.error("🚀 ~ file: index.js ~ line 582 ~ returnnewPromise ~ e", e)
        reject(e)
      }

      });

    },

  }
}
export default store


// WEBPACK FOOTER //
// ./src/store/saldo/index.js